module.exports = __webpack_public_path__ + "static/img/whatsapp.72fd26af.png";